module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-3-p-e7ddc731bc9117be7279eafd6428d22d.gif";